<div class="assessment-component">

  <div *ngIf="assessmentId !== null && quizForms.length" style="width: 100%;">
    <h3>{{quiz.quizData.name}} <i class="pi pi-list" (click)="openHistory()"></i></h3>
    <div [formGroup]="topForm">
      <mat-form-field>
        <mat-label>Completion Name</mat-label><input matInput name="completionName" formControlName="completionName"
                              required>
      </mat-form-field>
    </div>
    <mat-stepper [linear]="false" #stepper>
      <mat-step *ngFor="let step of quiz.quizData.steps; let i = index">
        <ng-template matStepLabel>
          <span [ngClass]="{'invalid': isValidated && !quizForms[i].valid}">{{step.name}}</span>
        </ng-template>
        <form [formGroup]="quizForms[i]" style="width: 100%;" *ngIf="i == stepper.selectedIndex">
          <div *ngFor="let item of step.items;let q = index" class="item" style="margin-top: 10px">
            <div style="flex-direction: row; display: flex;"
                 [ngStyle]="{display: isHidden[i] && (isHidden[i][q] === true) ? 'none': 'flex' }">
              <div style="flex:1 1 calc(100%)" class="question">
                <ng-container *ngIf="item.type == 'textQuestion' && !item.multiple">
                  <ng-container *ngIf="item.hasDetails">
                    <div [innerHTML]="item.details | sanitizeHtml"></div>
                  </ng-container>
                  <mat-form-field style="width: 100%">
                    <input matInput [name]="'r' + i + '_' + q" [formControlName]="'r' + i + '_' + q"
                           [placeholder]="(q + 1) + ') ' + item.name" />
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="item.type == 'textQuestion' && item.multiple"
                              [formGroupName]="'r' + i + '_' + q">
                  <ng-container *ngIf="item.hasDetails">
                    <div [innerHTML]="item.details | sanitizeHtml"></div>
                  </ng-container>
                  <mat-form-field style="width: 100%" *ngFor="let id of quizForms[i].controls['r' + i + '_' + q].list">
                    <input matInput [name]="'r' + i + '_' + q + '_' + id"
                           [formControlName]="'r' + i + '_' + q + '_' + id"
                           [placeholder]="(id == 0) ? ((q + 1) + ') ' + item.name) : null" />
                    <i class="pi pi-plus" (click)="addAnswer(i, 'r' + i + '_' + q)" matSuffix></i>
                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="item.type == 'question'">
                  <div style="display: flex; flex-direction: row; font-weight: bold;font-size: 1.2em;margin-bottom:10px;">
                    <span
                      [ngClass]="{'invalid': isValidated && !quizForms[i].controls['r' + i + '_' + q].valid}">{{q + 1}})&nbsp;</span>
                    <div>
                      <ng-container *ngIf="item.hasDetails">
                        <div style="display: inline;" [innerHTML]="item.details | sanitizeHtml"></div>
                        <br />
                      </ng-container>
                      <span
                        [ngClass]="{'invalid': isValidated && !quizForms[i].controls['r' + i + '_' + q].valid}">{{item.name}}</span>
                    </div>
                  </div>
                  <div style="margin-left: 10px;" *ngIf="!item.multiple">

                    <mat-radio-group [name]="'r' + i + '_' + q" [formControlName]="'r' + i + '_' + q">
                      <div *ngFor="let a of item.answers;let h = index" style="display: flex; flex-direction: row;">
                        <div style="flex:0 0 auto">
                          <mat-radio-button [value]="h">{{'ABCDEFGHIJKL'[h]}}. {{a.name}}</mat-radio-button>
                        </div>
                      </div>
                    </mat-radio-group>
                    <div *ngIf="item.hasPleaseExplain"
                         den="!(quizForm.controls['r' + i + '_' + q] && quizForm.controls['r' + i + '_' + q].value == (item.answers.length - 1))">
                      <mat-form-field style="width: 100%">
                        <input matInput [name]="'r' + i + '_' + q + '_pleaseexplain'"
                               [formControlName]="'r' + i + '_' + q + '_pleaseexplain'"
                               [placeholder]="item.pleaseExplainText || 'Please explain your answer.'">
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="margin-left: 10px;" *ngIf="item.multiple">
                    <div *ngFor="let a of item.answers;let h = index" style="display: flex; flex-direction: row;">
                      <div style="flex:0 0 50px">
                        <mat-checkbox [name]="'r' + i + '_' + q + '_' + h"
                                      [formControlName]="'r' + i + '_' + q + '_' + h">{{'ABCDEFGHIJKL'[h]}}
                          . {{a.name}}</mat-checkbox>
                      </div>
                    </div>
                    <div *ngIf="item.hasPleaseExplain"
                         den="!(quizForm.controls['r' + i + '_' + q + '_' + (item.answers.length - 1)] && quizForm.controls['r' + i + '_' + q + '_' + (item.answers.length - 1)].value)">
                      <mat-form-field style="width: 100%">
                        <mat-label>Prompt for User Explanation.</mat-label>
                        <input matInput [name]="'r' + i + '_' + q + '_pleaseexplain'"
                               [formControlName]="'r' + i + '_' + q + '_pleaseexplain'"
                               >
                      </mat-form-field>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="item.type == 'yesNoQuestion'">
                  <div style="display: flex; flex-direction: row; font-weight: bold; font-size: 1.2em; margin-bottom: 10px;">
                    <span [ngClass]="{'invalid': isValidated && !quizForms[i].controls['r' + i + '_' + q].valid}">
                      {{q + 1}})&nbsp;
                    </span>
                    <div>
                      <ng-container *ngIf="item.hasDetails">
                        <div style="display: inline;" [innerHTML]="item.details | sanitizeHtml"></div>
                        <br />
                      </ng-container>
                      <span [ngClass]="{'invalid': isValidated && !quizForms[i].controls['r' + i + '_' + q].valid}">
                        {{item.name}}
                      </span>
                    </div>
                  </div>

                  <mat-radio-group [name]="'r' + i + '_' + q" [formControlName]="'r' + i + '_' + q">
                    <div *ngFor="let a of item.answers; let h = index" style="display: flex; flex-direction: column;">
                      <div style="flex:0 0 auto">
                        <mat-radio-button [value]="h">{{a.name}}</mat-radio-button>
                      </div>
                      <div style="width: 100%; margin-top: 5px;" *ngIf="quizForms[i].controls['r' + i + '_' + q].value === h">
                        <mat-form-field style="width: 100%">
                          <mat-label>{{a.explanationText || 'Please explain your answer.'}}</mat-label>
                          <input matInput [name]="'r' + i + '_' + q + '_' + h + '_pleaseexplain'"
                                [formControlName]="'r' + i + '_' + q + '_' + h + '_pleaseexplain'"
                                style="width: 100%">
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-radio-group>
                </ng-container>


                <ng-container *ngIf="item.type == 'attachment'">

                  <div style="display: flex; flex-direction: row; font-weight: bold;font-size: 1.2em;margin-bottom:10px;">
                    {{q + 1}})&nbsp;
                    <ng-container *ngIf="item.hasDetails">
                      <div [innerHTML]="item.details | sanitizeHtml"></div>
                    </ng-container>
                    {{item.name}}
                  </div>
                  <div *ngFor="let file of files['r' + i + '_' + q]">
                    <span *ngIf="!file.showLink">{{file.name}}</span>
                    <a
                      href="{{api + '/api/attachments/file?name=' + encodeURIComponent(file.internalName) + '&path=Surveys/' + assessmentId + '/' + '&token=' + token}}"
                      target="_blank" *ngIf="file.showLink" rel="noopener">{{file.name}}</a>
                    <i class="pi pi-trash" (click)="deleteAttachment(file, files['r' + i + '_' + q])"></i>
                  </div>
                  <button mat-raised-button matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}"
                          (click)="inputFile.click()">
                    Add Attachment
                  </button>
                  <input #inputFile
                         type="file"
                         accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                         (change)="addAttachment('r' + i + '_' + q, $event)"
                         [style.display]="'none'">
                </ng-container>
              </div>
            </div>
          </div>
          <div *ngIf="i == quizForms.length - 1">
            <div>
              <div>I acknowledge that I have completed this survey.</div>
              <mat-form-field>
                <mat-label>Name</mat-label><input matInput name="userName" formControlName="userName"  required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field>
                <mat-label>Date</mat-label><input matInput name="userDate" formControlName="userDate" [matDatepicker]="picker1"
                                      required>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="controls">
            <button mat-raised-button *ngIf="i > 0"
                    matStepperPrevious
                    type="button">
              Previous
            </button>
            <button mat-raised-button *ngIf="i < (quiz.quizData.steps.length - 1)"
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button (click)="send(false)">Save</button>
            <button mat-raised-button (click)="send(true)" *ngIf="i == (quiz.quizData.steps.length - 1)">Submit
            </button>
          </div>
        </form>

      </mat-step>
    </mat-stepper>


    <div *ngIf="assessmentId === null" class="assessment-link">
      Please, select assessment
    </div>
  </div>
</div>
